
import { Component, Prop, Vue } from "vue-property-decorator";
import { calculateDistance } from "../../utils/util";
import { clearStoreSearchHistory } from "../../api/industryMall";
@Component
export default class ActivitySelect extends Vue {
  @Prop({ default: "" }) defaultValue?: string;
  @Prop({}) options?: any[]; // 活动列表数据

  defaultIndex = 0;
  show = false;
  selectedItem = {}
  openPop() {
    this.defaultIndex = this.options.findIndex(
      
      (item) => {
        console.log(item)
        return item.text === this.defaultValue}
    );
    // console.log('this.defaultIndex-----', this.defaultIndex)
    this.show = true;
  }
  onChange(picker, value, index) {
    this.selectedItem = value
    this.defaultIndex = index;
  }

  popupClose() {
    this.show = false;
  }

  confirmFn() {
    const name = this.options[this.defaultIndex];
    this.$emit("confirm", this.selectedItem);
    this.popupClose();
  }
  mounted() {
    this.defaultValue = this.options[0].text || "";
  }
}
